export default __webpack_public_path__ + "static/media/about-img.86934fbf.png";